import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';
import type { ComponentType } from 'react';

import type { CampaignCreateModalProps } from './CampaignCreateModal';

export const CampaignCreateModalLoader = (): Promise<typeof import('./CampaignCreateModalBoundary')> =>
  import(/* webpackChunkName: "4-feat-campaign-create" */ './CampaignCreateModalBoundary');

const LoadableCampaignCreateModal: ComponentType<CampaignCreateModalProps> = lazyLoadOnRender({
  loader: CampaignCreateModalLoader,
});
export default LoadableCampaignCreateModal;
